export default {
  REACT_APP_API_ENDPOINT: "web-production-a853.up.railway.app/api",
  //REACT_APP_API_ENDPOINT:"http://localhost:8000/api",
  REACT_APP_TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY,
  JWT_SECRET: process.env.JWT_SECRET,
  JWT_EXPIRY: process.env.JWT_EXPIRY,
};
